import { useAppSelector } from "../../../redux/hooks/hooks";
import {
  ElaborationStatus,
  selectElaborationStatusList,
} from "../../../redux/feature/object/remote-elaborations-slice";
import { useEffect, useMemo } from "react";
import { DOWNLOAD_COPY } from "../../../utils/constants/navigation";
import LoadingManager from "../../../common/loading/LoadingManager";

export function useHandleLoaderForDownloadCopy(): void {
  const elaborations = useAppSelector(selectElaborationStatusList);

  const downloadElaborations = useMemo((): ElaborationStatus[] => {
    if (!elaborations) return [];
    return elaborations
      .map((e) => ({
        ...e,
        items: e.items.filter(
          (item) => item.elaborationType === DOWNLOAD_COPY && (item.status === "REQUESTED" || item.status === "STARTED")
        ),
      }))
      .filter((e) => e.items.length > 0);
  }, [elaborations]);

  useEffect(() => {
    if (downloadElaborations.length)
      LoadingManager.create(DOWNLOAD_COPY, {
        isAbortable: true,
        items: downloadElaborations,
      });
    else LoadingManager.remove(DOWNLOAD_COPY);
  }, [downloadElaborations]);
}
